import { observable, action } from "mobx";
import { get, post } from "../services/ajax.service";
import jwt_decode from "jwt-decode";
import setAuthToken from "../utils/setAuthToken";
import isEmpty from "../utils/isEmpty";
import SessionTimeout from "../helpers/SessionTimeout.helper";
class AuthStore {
  @observable user = {};
  @observable email_sent = false
  @observable password_reset = false
  @observable loading = false;
  @observable isAuthenticated = false;
  @observable error = "";
  @observable previous_portal = "";
  @observable login_blocked = false;
  @observable hippa_client_toggle = false;
  @observable uuid_token = {};

  @action set_client_hippa(toggle) {
    this.hippa_client_toggle = toggle;
  }

  @action setDefaults = () => {
    this.email_sent = false;
    this.password_reset = false;
    this.login_blocked = false;
  }
  @action clearErrors = () => {
    this.error=""
  }
  @action login = async (data, history) => {
    this.loading = true;
    this.error = "";
    try {
      const login = await post("/api/v1/authactions/login", data);
      const { token, initialLogin, email, preventLogin, show_2fa_prompt } = login.data;
      if (show_2fa_prompt) {
        const token = login.data.token;
        this.uuid_token = token
        history.push(`/two_factor_authentication/${token}`)
        return;
      }
      else {
        sessionStorage.setItem("jwtToken", token);
        setAuthToken(token);
        let preferences = await get("/api/v1/secureAuthUserActions/getPreferences");
        sessionStorage.setItem("preferences", preferences.data.token);
        const decoded = jwt_decode(token);
        preferences = await jwt_decode(preferences.data.token)
        this.setUser(decoded, preferences);
        history.push("/");
      }
    } catch (err) {
      console.log(err);
      this.error = err?.response?.data;
      return err?.response?.data;
    }
    finally {
      this.loading = false;

    }
  };

  @action verify_2fa_v2 = async (data, history) => {
    this.loading = true;
    this.error = "";
    try {
      const verify = await post("/api/v1/authactions/verify_2fa_v2", data);
      if (verify.data.status == "SUCCESS") {
        const token = verify.data.token.token;
        sessionStorage.setItem("jwtToken", token);
        setAuthToken(token);
        let preferences = await get("/api/v1/secureAuthUserActions/getPreferences");
        sessionStorage.setItem("preferences", preferences.data.token);
        const decoded = jwt_decode(token);
        preferences = await jwt_decode(preferences.data.token)
        this.setUser(decoded, preferences);
        history.push("/");
        return;
      }
    } catch (e) {
      console.log(e);
      this.error = e.response.data;
    }
    this.loading = false
  }

  @action loginAs = async (id) => {
    try {
      let login = await post(`/api/v1/secureAuthActions/loginas`, { id: id })

      return login.data.token;

    }
    catch (err) {
      console.log(err.response.data)
    }
  };

  @action setLoginAs = async (token, history) => {
    try {
      sessionStorage.setItem("jwtToken", token);
      setAuthToken(token);
      let preferences = await get("/api/v1/secureAuthUserActions/getPreferences");
      sessionStorage.setItem("preferences", preferences.data.token);
      const decoded = jwt_decode(token);
      preferences = jwt_decode(preferences.data.token)
      this.setUser(decoded, preferences);
      history.push("/");
    }
    catch (err) {
      this.error = err.response.data;
    }
  }

  @action request_recover_password = async (data, history) => {
    this.loading = true;
    this.error = "";
    try {
      await post(`/api/v1/authactions/request_recover_password`, data);
      this.email_sent = true;
      history.push("/login");
    }
    catch (err) {
      this.error = err.response.data;
    }
    this.loading = false;
  }

  @action SendInviteToUsersDrafts = async (data) => {
    this.loading = true;
    this.error = "";
    try {
      return await post(`/api/v1/authactions/SendInviteToUsersDrafts`, data);
    }
    catch (err) {
      this.error = err.response.data;
    }
    this.loading = false;
  }

  @action SendInviteToUsersDraftsVerify = async (data) => {
    this.loading = true;
    this.error = "";
    try {
      return await get(`/api/v1/authactions/SendInviteToUsersDraftsVerify/${data}`);
    }
    catch (err) {
      this.error = err.response.data;
      return this.error;
    }
    finally {
      this.loading = false;
    }
  }

  @action UpdateDraftUser = async (data) => {
    this.loading = true;
    this.error = "";
    try {
      return await post(`/api/v1/authactions/updateDraftUser`, data);
    }
    catch (err) {
      this.error = err.response.data;
      return this.error
    }
    finally {
      this.loading = false;
    }
  }

  @action validate_reset_password = async (data) => {
    this.error = "";
    try {
      await post(`/api/v1/authactions/validate_password_reset`, data);
      return true;
    }
    catch (err) {
      return false;
    }
  }
  @action reset_password = async (data, history) => {
    this.loading = true;
    this.error = "";
    try {
      await post(`/api/v1/authactions/passwordreset`, data);
      this.password_reset = true;
      history.push("/login");
    }
    catch (err) {
      this.error = err.response.data.password;
    }

    this.loading = false;
  }

  @action setUser(decoded, preferences) {
    this.isAuthenticated = !isEmpty(decoded);
    this.isAuthenticated = !isEmpty(preferences)
    this.user = decoded;
    SessionTimeout()
    if (preferences) {
      Object.keys(preferences).forEach((key, index) => {
        this.user[key] = preferences[key];
      });
    }

  }

  @action logout(history) {
    localStorage.removeItem("group_id")
    localStorage.removeItem("filter_groups")
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("preferences");
    localStorage.removeItem("inflation");
    setAuthToken(false);
    this.setUser({});
    window.location.href = "/login"
  }
}

export default AuthStore;
